export const WARN_BY_STATE = {
  EMAIL: 'alertByEmail',
  SMS: 'alertBySms',
  EMAILANDSMS: 'alertByEmailAndSms'
} as const;

export const WARN_BY = [
  WARN_BY_STATE.EMAIL,
  WARN_BY_STATE.SMS,
  WARN_BY_STATE.EMAILANDSMS
];

export const SPLIT_DESIGNATION_KEY = '--appellation_';

export const PRIMEUR_TABS = {
  SEARCH: 'search',
  ALERTS: 'alerts',
  PREFERENCES: 'preferences',
};

export const MAIL_CHECK = {
  IS_USER: 'IS_USER',
  IS_PRIMEUR_USER: 'IS_PRIMEUR_USER'
};

export const UPDATE_PRIMEUR_USER = {
  ALREADY_EXIST: 'ALREADY_EXIST',
  UPDATED: 'UPDATED'
};
